
import moment from "moment";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CancelButton from "../buttons/CancelButton.vue";
import DangerButton from "../buttons/DangerButton.vue";
import EditFrame from "../EditFrame.vue";

@Component({
  components: {
    EditFrame,
    CancelButton,
    DangerButton
  }
})
export default class RentalDuration extends Vue {
  @Prop()
  maxPrebookDuration!: string;

  @Prop()
  maxRentalDuration!: string;

  @Prop()
  minInterBookingDuration!: string;

  @Prop({ default: "PT0M" })
  earlyGracePeriod!: string;

  @Prop({ default: "PT0M" })
  lateGracePeriod!: string;

  @Prop()
  capacity!: number;

  @Prop({
    default: false
  })
  hideControls!: boolean;

  @Prop({ default: false }) editMode!: boolean;

  maxPrebookDurationD = 0;
  maxRentalDurationD = 0;
  minInterBookingDurationH = 0;
  earlyGracePeriodM = 0;
  lateGracePeriodM = 0;

  mounted (): void {
    this.importData();
  }

  @Watch("maxPrebookDuration")
  @Watch("maxRentalDuration")
  @Watch("minInterBookingDuration")
  @Watch("earlyGracePeriod")
  @Watch("lateGracePeriod")
  onDurationChanged (): void {
    this.importData();
  }

  importData (): void {
    this.maxRentalDurationD = moment.duration(this.maxRentalDuration).asDays();
    this.maxPrebookDurationD = moment
      .duration(this.maxPrebookDuration)
      .asDays();
    this.minInterBookingDurationH = moment
      .duration(this.minInterBookingDuration)
      .asHours();
    this.earlyGracePeriodM = moment.duration(this.earlyGracePeriod).asMinutes();
    this.lateGracePeriodM = moment.duration(this.lateGracePeriod).asMinutes();
  }

  onInput (): void {
    this.$emit("input", {
      maxPrebookDuration: moment
        .duration(this.maxPrebookDurationD, "days")
        .toISOString(),
      maxRentalDuration: moment
        .duration(this.maxRentalDurationD, "days")
        .toISOString(),
      minInterBookingDuration: moment
        .duration(this.minInterBookingDurationH, "hours")
        .toISOString(),
      earlyGracePeriod: moment
        .duration(this.earlyGracePeriodM, "minutes")
        .toISOString(),
      lateGracePeriod: moment
        .duration(this.lateGracePeriodM, "minutes")
        .toISOString()
    });
  }
}
